// extracted by css-extract-rspack-plugin
export default {"labNameContainer":"labNameContainer-C6tW8v","namesWrapper":"namesWrapper-A1OwcH","labNameButton":"labNameButton-uM1Vii"};